export default __webpack_public_path__ + "static/media/PAULAS CHOICE INTERVIEW_FINWEB2.3ce98d76.png";